import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { ArrowClockwiseIcon, CheckCircleIcon, HouseIcon } from '@phosphor-icons/react';
import { LoaderOne } from '../components/ui/loader';
import moment from 'moment';

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const TestSubmission = () => {
  const { pack, test } = useParams();
  const query = useQuery();
  const type = query.get('type');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmissionInProgress, setIsSubmissionInProgress] = useState(false);
  const [detailAccessDate, setDetailAccessDate] = useState('2026-01-17T13:30:00.000+00:00');

  const checkSubmissionStatus = async () => {
    try {
      const res = await axios.get(`/api/v2/test/${pack}/${test}/check-submission`);
      const { isSubmitted, isSubmissionInProgress, detailAccessDate } = res?.data?.data || {};
      setIsSubmitted(isSubmitted);
      setIsSubmissionInProgress(isSubmissionInProgress);
      setDetailAccessDate(detailAccessDate);

      if (isSubmitted) {
        window.location.href = `/v2/home`;
      }
    } catch (error) {
      console.error('Error checking submission status:', error);
    }
  };

  useEffect(() => {
    checkSubmissionStatus(); // initial call

    const interval = setInterval(() => {
      checkSubmissionStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [pack, test]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-4 relative">
      <div className="text-center max-w-2xl mx-auto">
        <h1 className="flex items-center justify-center gap-3 text-4xl sm:text-5xl font-semibold text-gray-900">
          {type === 'early' ? 'Test Completed' : 'Test Submitted'}
          <CheckCircleIcon size={50} weight="fill" className="text-green-600" />
        </h1>

        <p className="mt-2 text-lg font-medium text-gray-700">
          {type === 'early'
            ? 'This test has been submitted already.'
            : `Good things take time! You can check your result on ${moment(detailAccessDate)
                .utc()
                .utcOffset(330)
                .format('DD MMM YYYY, hh:mm A')}.`}
        </p>

        {isSubmissionInProgress && (
          <div className="mt-5 flex flex-col items-center justify-center gap-10">
            {/* <LoaderOne /> */}
            <button
              onClick={() => (window.location.href = '/v2/home')}
              className="cursor-pointer flex flex-row items-center justify-center gap-2 bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 text-lg px-6 py-3 rounded-lg transition-colors duration-200"
            >
              <HouseIcon size={22} />
              Go Home
            </button>
          </div>
        )}
      </div>

      <div className="absolute bottom-4 w-full flex justify-center">
        <p className="text-sm text-gray-500">You'll get an email once the result is available</p>
      </div>
    </div>
  );
};

export default TestSubmission;
